import React from "react";
import { Select, MenuItem, FormControl } from "@mui/material";

const Pagination = (props) => {
  const handleSizeChange = (e) => {
    props.setSelectedSize(e.target.value);
  };

  const requestPageNumber = (PageNumber) => {
    props.RequestPageNumber(PageNumber);
  };

  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= props.Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
    if (NextPage > 1 && props.Pages.length > 1) {
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= props.Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
    if (PrevPage === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
  };

  const displayEnd = () => {
    let End = parseInt(props.SelectedStart * props.SelectedSize);
    if (End > props.TotalElements) {
      return props.TotalElements;
    } else {
      return End;
    }
  };

  const displayStart = () => {
    let Start = props.SelectedStart;
    let End = parseInt(props.SelectedStart * props.SelectedSize);

    if (Start === 1) {
      return 1;
    } else {
      return parseInt(End - props.SelectedSize + 1);
    }
  };

  return (
    <div className="info-footer" id="info-footer">
      <div className="pagenumber-summary">
        {"Showing"} <p id="start">{displayStart()}</p>
        {"to"} <p id="end">{displayEnd()}</p>
        {"of"} {props.TotalElements} {"items"}.
      </div>
      <section className="pagination-holder">
        <button
          onClick={() => requestPrevPage()}
          id="prev-page"
          className="page-btn page-btn-disabled"
        >
          <i className="feather-chevron-left"></i>
        </button>
        <React.Fragment>
          {props.Pages.length < 6 ? (
            <React.Fragment>
              {props.Pages.map((Page) => (
                <React.Fragment>
                  {Page === 1 ? (
                    <button
                      key={Page}
                      onClick={() => requestPageNumber(Page)}
                      className="page-btn active-page"
                      id={Page + "-page-btn"}
                    >
                      {Page}
                    </button>
                  ) : (
                    <button
                      key={Page}
                      onClick={() => requestPageNumber(Page)}
                      className="page-btn"
                      id={Page + "-page-btn"}
                    >
                      {Page}
                    </button>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <button
                onClick={() => requestPageNumber(1)}
                className="page-btn active-page"
                id={1 + "-page-btn"}
              >
                {1}
              </button>
              {props.PageInfo.FirstDotsShown ? <p>...</p> : null}
              <button
                onClick={() =>
                  requestPageNumber(parseInt(props.PageInfo.MiddlePage - 1))
                }
                className="page-btn"
                id={parseInt(props.PageInfo.MiddlePage - 1) + "-page-btn"}
              >
                {parseInt(props.PageInfo.MiddlePage - 1)}
              </button>
              {props.PageInfo.MiddlePage === props.PageInfo.LastPage ? null : (
                <button
                  onClick={() => requestPageNumber(props.PageInfo.MiddlePage)}
                  className="page-btn"
                  id={props.PageInfo.MiddlePage + "-page-btn"}
                >
                  {props.PageInfo.MiddlePage}
                </button>
              )}
              {parseInt(props.PageInfo.MiddlePage + 1) >=
              props.PageInfo.LastPage ? null : (
                <button
                  onClick={() =>
                    requestPageNumber(parseInt(props.PageInfo.MiddlePage + 1))
                  }
                  className="page-btn "
                  id={parseInt(props.PageInfo.MiddlePage + 1) + "-page-btn"}
                >
                  {parseInt(props.PageInfo.MiddlePage + 1)}
                </button>
              )}
              {!props.PageInfo.LastDotsShown ? <p>...</p> : null}
              <button
                onClick={() => requestPageNumber(props.PageInfo.LastPage)}
                className="page-btn"
                id={props.PageInfo.LastPage + "-page-btn"}
              >
                {props.PageInfo.LastPage}
              </button>
            </React.Fragment>
          )}
        </React.Fragment>

        <button
          onClick={() => requestNextPage()}
          id="next-page"
          className={
            props.Pages.length === 1 ? "page-btn page-btn-disabled" : "page-btn"
          }
        >
          <i className="feather-chevron-right"></i>
        </button>
      </section>
      <div className="row-count-select">
        <p className="row-info">{"Rows per page"}</p>
        <FormControl variant="outlined" sx={{ marginTop: "16px" }}>
          <Select
            labelId="status-label"
            id="rows-per-page"
            value={props.SelectedSize ? props.SelectedSize : 5}
            onChange={handleSizeChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "#171717", // Change border color
              },
              width: "80px",
              height: "40px",
            }}
          >
            <MenuItem value="5">5</MenuItem>
            <MenuItem value="10">10</MenuItem>
            <MenuItem value="25">25</MenuItem>
            <MenuItem value="50">50</MenuItem>
            <MenuItem value="100">100</MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default Pagination;
